import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../services/storage.service'
import Code from '../views/Code.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Dash from '../views/Dash.vue'
import Dashboard2 from '../views/AdminTasks/Secret.vue'

import Customers from  '../views/Customer/Listing.vue'
import Customer from  '../views/Customer/Single.vue'
import NewCustomer from '../views/Customer/New.vue'

import Users from  '../views/Users.vue'
import User from '../views/User.vue'
import NewUser from '../views/NewUser.vue'

import Jobs from '../views/Jobs/Listing.vue'
import JobMain from  '../views/Jobs/Main.vue'
import JobActivities from '../views/Jobs/ActivityLog.vue'
import JobWarranty from '../views/Jobs/Warranty.vue'
import JobIssues from '../views/Jobs/IssueTracker.vue'
import JobEquipment from '../views/Jobs/Equipment.vue'
import JobPunchlist from '../views/Jobs/Punchlist.vue'
import JobCustomPunchlist from '../views/Jobs/CustomPunchlist.vue'
import JobPhaseList from '../views/Jobs/PhaseList.vue'
import JobChat from '../views/Jobs/Chat.vue'
import JobImages from '../views/Jobs/Images.vue' 
import JobAssignees from '../views/Jobs/Assignees.vue' 
import JobDetails from '../views/Jobs/JobDetails.vue'
import NewJob from '../views/Jobs/New.vue'

import Calendar from '../views/Calendar.vue'
import CustomCalendar from '../views/CustomCalendar.vue'

import Leads from  '../views/Leads.vue'
import Lead from  '../views/Lead.vue'

import ManagePhases from '../views/ManagePhases.vue'

import Teams from '../views/Teams/Listing.vue'
import TeamCalendar from '../views/Teams/Jobs.vue'
import TeamHistory from '../views/Teams/History.vue'
import Settings from '../views/Settings/Settings.vue'

import IssuesTracker from '../views/IssuesTracker.vue'

import Reports from '../views/Reports/Reports.vue'
import JobsReport from '../views/Reports/JobsReport.vue'
import LeadsReport from '../views/Reports/LeadsReport.vue'

import NewIssue from '../views/Workorder/New.vue'
import WoEdit from '../views/Workorder/Edit.vue'
import Workorders from '../views/Workorder/Listing.vue'

import ItNew from '../views/Issues/New.vue'
import ItEdit from '../views/Issues/Edit.vue'
import ItIssues from '../views/Issues/Listing.vue'

import SiNew from '../views/ServiceIssues/New.vue'
import SiEdit from '../views/ServiceIssues/Edit.vue'
import SiIssues from '../views/ServiceIssues/Listing.vue'

import AtNew from '../views/AdminTasks/New.vue'
import AtEdit from '../views/AdminTasks/Edit.vue'

import DepositsNew from '../views/Deposits/New.vue'
import DepositsEdit from '../views/Deposits/Edit.vue'
import Deposits from '../views/Deposits/Listing.vue'

import SendSms from '../views/SendSms.vue'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/dash',
    name: 'Dash',
    component: Dash,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/admindash',
    name: 'Dashboard Admin',
    component: Dashboard2,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/newcustomer',
    name: 'New Customer',
    component: NewCustomer,
    meta: {
      title: 'Create a Customer',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/customer/:id',
    name: 'Customer',
    component: Customer,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/customers/get',
      title: 'Edit Customer',
      key: 'customer'
    }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/customers/all?page=',
      title: 'All Customers',
      key: 'all'
    }
  },
  {
    path: '/newuser',
    name: 'New User',
    props: true,
    component: NewUser,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/newsms',
    name: 'New Sms',
    props: true,
    component: SendSms,
    meta: {
      title: 'Send SMS',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/users/all?page=',
      title: 'All Users',
      key: 'all'
    }
  },
  {
    path: '/user/:id',
    name: 'User',
    component: User,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/users/get',
      title: 'User',
      key: 'user'
    }
  },
  {
    path: '/code',
    name: 'Code',
    component: Code,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/teams',
    name: 'Teams',
    component: Teams,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      title: 'Teams',
      key: 'teams'
    }
  },
  {
    path: '/team_calendar/:id',
    name: 'Team Calendar',
    props: true,
    component: TeamCalendar,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'crm/team/calendar?id=',
    }
  },
  {
    path: '/team_history',
    name: 'Team History',
    props: true,
    component: TeamHistory,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'crm/team/daily?date=',
    }
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: Jobs,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/all?page=',
      title: 'Jobs',
      key: 'all'
    }
  },
  {
    path: '/job/main/:id',
    name: 'JobMain',
    component: JobMain,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/get',
      title: 'Job',
      key: 'job_main'
    }
  },
  {
    path: '/job/activities/:id',
    name: 'JobActivities',
    component: JobActivities,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/activities',
      title: 'Activities',
      key: 'job_activities'
    }
  },
  {
    path: '/job/warranty/:id',
    name: 'JobWarranty',
    component: JobWarranty,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/warranties',
      title: 'Warranty',
      key: 'job_warranties'
    }
  },
  {
    path: '/job/equipment/:id',
    name: 'JobEquipment',
    component: JobEquipment,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/equipment',
      title: 'Equipment',
      key: 'job_equipment'
    }
  },
  {
    path: '/job/issue_tracker/:id',
    name: 'JobIssues',
    component: JobIssues,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/issues',
      title: 'Issues',
      key: 'job_issues'
    }
  },
  {
    path: '/job/punch_list/:id',
    name: 'JobPunchlist',
    component: JobPunchlist,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/punchlist',
      title: 'Punchlist',
      key: 'job_punchlist'
    }
  },
  {
    path: '/job/custom_punch_list/:id',
    name: 'JobCustomPunchlist',
    component: JobCustomPunchlist,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/cpunchlist',
      title: 'Custom Punchlist',
      key: 'job_custom_punchlist'
    }
  },
  {
    path: '/job/phase_list/:id',
    name: 'JobPhaseList',
    component: JobPhaseList,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      title: 'Phase List',
      key: 'job_phaselist'
    }
  },
  {
    path: '/job/chat/:id',
    name: 'JobChat',
    component: JobChat,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/comments',
      title: 'Chat',
      key: 'job_chat'
    }
  },
  {
    path: '/job/media/:id',
    name: 'JobImages',
    component: JobImages,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/images',
      title: 'Images',
      key: 'job_images'
    }
  },
  {
    path: '/job/assignees/:id',
    name: 'JobAssignees',
    component: JobAssignees,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/assignees',
      title: 'Assignees',
      key: 'job_assignees'
    }
  },
  {
    path: '/job/details/:id',
    name: 'JobDetails',
    component: JobDetails,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/get',
      title: 'Edit Job Details',
      key: 'job_details'
    }
  },
  {
    path: '/newjob',
    name: 'New Job',
    props: true,
    component: NewJob,
    meta: {
      title: 'Create a Job',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/calendar',
    name: 'Calendar',
    props: true,
    component: Calendar,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'crm/calendar',
    }
  },
  {
    path: '/custom_calendar',
    name: 'CustomCalendar',
    props: true,
    component: CustomCalendar,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'crm/custom_calendar/get',
    }
  },
  {
    path: '/phases',
    name: 'Phases',
    props: true,
    component: ManagePhases,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/lead/:id',
    name: 'Lead',
    component: Lead,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/leads/get',
      title: 'Lead',
      key: 'lead'
    }
  },
  {
    path: '/leads',
    name: 'Leads',
    component: Leads,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/leads/all?page=',
      title: 'All Leads',
      key: 'all'
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      title: 'Settings',
      key: 'settings'
    }
  },
  {
    path: '/issues_tracker',
    name: 'Issues Tracker',
    component: IssuesTracker,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      title: 'Issues Tracker',
      key: 'issues_tracker'
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    props: true,
    component: Reports,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Generate Reports',
    }
  },
  {
    path: '/job_report',
    name: 'Job Report',
    props: true,
    component: JobsReport,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Completed Job Report',
    }
  },
  {
    path: '/lead_report',
    name: 'Leads Report',
    props: true,
    component: LeadsReport,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Leads Report',
    }
  },
  {
    path: '/newwo',
    name: 'New Workorder',
    props: true,
    component: NewIssue,
    meta: {
      title: 'Create a Workorder',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/wo/:id',
    name: 'Workorder Edit',
    component: WoEdit,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/wo/get',
      title: 'Workorder',
      key: 'wo_main'
    }
  },
  {
    path: '/workorders',
    name: 'Workorders',
    component: Workorders,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/wo/all?page=',
      title: 'Workorders',
      key: 'all'
    }
  },
  {
    path: '/newit',
    name: 'New Issue',
    props: true,
    component: ItNew,
    meta: {
      title: 'Create a Job',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/it/:id',
    name: 'Issue Edit',
    component: ItEdit,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/it/get',
      title: 'Job',
      key: 'it_main'
    }
  },
  {
    path: '/itissues',
    name: 'Issues',
    component: ItIssues,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/issues/get?page=',
      title: 'Jobs',
      key: 'all'
    }
  },
  {
    path: '/newadmintask',
    name: 'New Admin Task',
    props: true,
    component: AtNew,
    meta: {
      title: 'Create a Task',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/at/:id',
    name: 'Admin Task Edit',
    component: AtEdit,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/admin/task/get',
      title: 'Task',
      key: 'it_main'
    }
  },
  {
    path: '/newsi',
    name: 'New Issue',
    props: true,
    component: SiNew,
    meta: {
      title: 'Create a Job',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/si/:id',
    name: 'Issue Edit',
    component: SiEdit,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/si/get',
      title: 'Job',
      key: 'it_main'
    }
  },
  {
    path: '/serviceissues',
    name: 'Issues',
    component: SiIssues,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/service/issues/get?page=',
      title: 'Jobs',
      key: 'all'
    }
  },
  {
    path: '/new_deposit',
    name: 'New Deposit',
    props: true,
    component: DepositsNew,
    meta: {
      title: 'Create a Deposit',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/deposit/:id',
    name: 'Deposit Edit',
    component: DepositsEdit,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/deposit/get',
      title: 'Deposit',
      key: 'it_main'
    }
  },
  {
    path: '/deposits',
    name: 'Deposits',
    component: Deposits,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crm/job/deposits/get?page=',
      title: 'Deposits',
      key: 'all'
    }
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.afterEach((to, from) => {
  if(router.app.$store)
    router.app.$store.commit('menu/SET_LAST_ROUTE', from.name)
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/dashboard')
  }
  next();
}) 

export default router